import * as colorPalette from '../palette';

export const pageBackground = colorPalette.gray900;
export const pageBackgroundModalActive = colorPalette.gray800;
export const pageBackgroundTopLeft = colorPalette.navy800;
export const pageBackgroundBottomRight = colorPalette.gray700;
export const pageBackgroundLineTop = colorPalette.purple400;
export const pageBackgroundLineMid = colorPalette.navy900;
export const pageBackgroundLineBottom = colorPalette.navy150;
export const pageText = colorPalette.navy150;
export const pageTextLight = pageText;
export const pageTextSubdued = colorPalette.navy500;
export const altpageTextSubdued = pageTextSubdued;
export const pageTextPositive = colorPalette.purple200;
export const pageTextLink = colorPalette.purple400;

export const modalBackground = colorPalette.gray800;
export const modalBorder = colorPalette.navy600;

export const cardBackground = colorPalette.gray800;
export const cardBorder = colorPalette.purple400;
export const cardShadow = colorPalette.navy700;

export const tableBackground = colorPalette.navy800;
export const tableRowBackgroundHover = colorPalette.navy700;
export const tableText = colorPalette.navy150;
export const altTableText = tableText;
export const tableTextSelected = colorPalette.navy150;
export const tableTextHover = colorPalette.navy400;
export const tableTextEditing = colorPalette.black;
export const tableTextEditingBackground = colorPalette.purple400;
export const tableTextInactive = colorPalette.navy500;
export const tableHeaderText = colorPalette.navy300;
export const tableHeaderBackground = colorPalette.navy700;
export const tableBorder = colorPalette.navy600;
export const tableBorderSelected = colorPalette.purple400;
export const tableBorderHover = colorPalette.purple300;
export const tableBorderSeparator = colorPalette.navy400;
export const tableRowBackgroundHighlight = colorPalette.purple800;
export const tableRowBackgroundHighlightText = colorPalette.navy150;
export const tableRowHeaderBackground = colorPalette.navy700;
export const tableRowHeaderText = colorPalette.navy150;

export const sidebarBackground = colorPalette.navy800;
export const sidebarItemBackground = colorPalette.navy800;
export const sidebarItemBackgroundSelected = colorPalette.navy800;
export const sidebarItemBackgroundHover = colorPalette.navy700;
export const sidebarItemAccent = colorPalette.navy800;
export const sidebarItemAccentSelected = colorPalette.purple400;
export const sidebarItemAccentHover = colorPalette.navy700;
export const sidebarItemText = colorPalette.navy150;
export const sidebarItemTextSelected = colorPalette.purple400;
export const sidebarItemTextHover = colorPalette.navy150;

export const tooltipBackground = colorPalette.navy600;
export const tooltipBorder = colorPalette.navy500;

export const menuBackground = colorPalette.navy600;
export const menuItemBackground = colorPalette.navy600;
export const menuItemBackgroundHover = colorPalette.navy500;
export const menuItemText = colorPalette.navy100;
export const menuItemTextHover = colorPalette.navy50;
export const menuItemTextSelected = colorPalette.navy200;
export const menuItemTextHeader = colorPalette.purple300;
export const menuBorder = colorPalette.navy800;
export const menuBorderHover = colorPalette.purple400;
export const menuKeybindingText = colorPalette.navy500;
export const altMenuBackground = colorPalette.navy700;
export const altMenuItemBackground = colorPalette.navy700;
export const altMenuItemBackgroundHover = colorPalette.navy600;
export const alt2MenuItemBackgroundHover = altMenuItemBackgroundHover;
export const altMenuItemText = colorPalette.navy150;
export const altMenuItemTextHover = colorPalette.navy150;
export const altMenuItemTextSelected = colorPalette.purple400;
export const altMenuItemTextHeader = colorPalette.purple500;
export const alt2MenuItemTextHeader = altMenuItemTextHeader;
export const altMenuBorder = colorPalette.navy200;
export const altMenuBorderHover = colorPalette.purple400;

export const mobileNavBackground = colorPalette.navy800;
export const mobileNavItem = colorPalette.navy150;
export const mobileNavItemSelected = colorPalette.purple400;
export const mobileAccountShadow = cardShadow;
export const mobileAccountText = colorPalette.blue800;

// Mobile view themes (for the top bar)
export const mobileAccountViewTheme = colorPalette.navy50;
export const mobileAccountsViewTheme = colorPalette.blue800;
export const mobileBudgetViewTheme = colorPalette.purple500;
export const mobileConfigServerViewTheme = colorPalette.purple500;
export const mobileSettingsViewTheme = colorPalette.navy50;
export const mobileTransactionViewTheme = colorPalette.purple500;

// Button
export const buttonMenuText = colorPalette.navy100;
export const buttonMenuTextHover = colorPalette.navy50;
export const buttonMenuBackground = 'transparent';
export const buttonMenuBackgroundHover = 'rgba(200, 200, 200, .25)';
export const buttonMenuBorder = colorPalette.navy500;
export const buttonMenuSelectedText = colorPalette.green800;
export const buttonMenuSelectedTextHover = colorPalette.orange800;
export const buttonMenuSelectedBackground = colorPalette.orange200;
export const buttonMenuSelectedBackgroundHover = colorPalette.orange300;
export const buttonMenuSelectedBorder = buttonMenuSelectedBackground;

export const buttonPrimaryText = colorPalette.white;
export const buttonPrimaryTextHover = buttonPrimaryText;
export const buttonPrimaryBackground = colorPalette.purple400;
export const buttonPrimaryBackgroundHover = buttonPrimaryBackground;
export const buttonPrimaryBorder = buttonPrimaryBackground;
export const buttonPrimaryShadow = 'rgba(0, 0, 0, 0.6)';
export const buttonPrimaryDisabledText = colorPalette.navy700;
export const buttonPrimaryDisabledBackground = colorPalette.navy400;
export const buttonPrimaryDisabledBorder = buttonPrimaryDisabledBackground;

export const buttonNormalText = colorPalette.navy150;
export const buttonNormalTextHover = colorPalette.navy150;
export const buttonNormalBackground = colorPalette.navy800;
export const buttonNormalBackgroundHover = colorPalette.navy600;
export const buttonNormalBorder = colorPalette.navy300;
export const buttonNormalShadow = 'rgba(0, 0, 0, 0.4)';

export const altbuttonMenuBackground = buttonNormalBackground;
export const buttonNormalSelectedText = colorPalette.white;
export const buttonNormalSelectedBackground = colorPalette.purple600;

export const buttonNormalDisabledText = colorPalette.navy500;
export const buttonNormalDisabledBackground = colorPalette.navy800;
export const buttonNormalDisabledBorder = colorPalette.navy500;

export const buttonBareText = buttonNormalText;
export const buttonBareTextHover = buttonNormalText;
export const buttonBareBackground = 'transparent';
export const buttonBareBackgroundHover = 'rgba(200, 200, 200, .3)';
export const buttonBareBackgroundActive = 'rgba(200, 200, 200, .5)';
export const buttonBareDisabledText = buttonNormalDisabledText;
export const buttonBareDisabledBackground = buttonBareBackground;

export const noticeBackground = colorPalette.green800;
export const noticeText = colorPalette.green300;
export const noticeAccent = colorPalette.green500;
export const warningBackground = colorPalette.orange800;
export const warningText = colorPalette.orange200;
export const warningAccent = colorPalette.orange500;
export const errorBackground = colorPalette.red800;
export const errorText = colorPalette.red200;
export const errorAccent = colorPalette.red500;

export const formLabelText = colorPalette.purple150;
export const altFormLabelText = formLabelText;
export const formInputBackground = colorPalette.navy800;
export const formInputBackgroundSelected = colorPalette.navy700;
export const formInputBackgroundSelection = colorPalette.purple400;
export const formInputBorder = colorPalette.navy600;
export const formInputTextReadOnlySelection = colorPalette.navy800;
export const formInputBorderSelected = colorPalette.purple400;
export const altFormInputBorderSelected = formInputBorderSelected;
export const formInputText = colorPalette.navy150;
export const formInputTextSelected = colorPalette.black;
export const formInputTextPlaceholder = colorPalette.navy150;
export const formInputTextPlaceholderSelected = colorPalette.navy100;
export const formInputTextSelection = colorPalette.navy800;
export const formInputShadowSelected = colorPalette.purple200;
export const altFormInputShadowSelected = formInputShadowSelected;
export const formInputTextHighlight = colorPalette.purple400;

export const pillBackground = colorPalette.navy600;
export const pillText = colorPalette.navy200;
export const pillTextHighlighted = colorPalette.purple500;
export const pillBorder = colorPalette.navy700;
export const pillBackgroundSelected = colorPalette.purple600;
export const pillTextSelected = colorPalette.navy150;
export const pillBorderSelected = colorPalette.purple400;
export const altPillBackground = pillBackground;
export const altPillText = pillText;
export const alt2PillText = pillText;
